module.exports = __webpack_public_path__ + "img/jiejing4.cc4bb05d.png";